// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3o82g","name":"ConsentHeader_name__3d8XW","birthday":"ConsentHeader_birthday__3Z9bu","skeleton":"ConsentHeader_skeleton__4r6Cd"};